import React from 'react';
import { Gift, AlertTriangle, ShieldCheck, ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
const bonuses = [{
  number: 1,
  title: 'El Ritual 7×1 (Starter Kit)',
  description: 'Todo lo que necesitás para arrancar hoy: guía paso a paso, checklist, tracker de 7 días y tarjeta de heladera con tus 3 reglas diarias.',
  image: 'https://cdn.magicpatterns.com/uploads/qojd7ppLZJzCA1AcsA5WFN/El-Ritual-71-Starter-Kit.png',
  value: '$890 UYU',
  quote: 'Si es fácil, se sostiene. Este kit existe para que no haya excusa el Día 1.'
}, {
  number: 2,
  title: 'Guía de Señales Silenciosas',
  description: 'Aprendé a leer las 3 ventanas del día (mañana, post-comida, noche) para saber si lo que sentís es una señal de alerta o solo ruido. Incluye semáforo visual y guion para hablar con tu médico.',
  image: 'https://cdn.magicpatterns.com/uploads/5FUU7LAuS9NjgnP1JSwzAp/Tu-cuerpo-avisa-en-silencio-antes-de-gritar.png',
  value: '$590 UYU',
  quote: 'Cuando escuchás temprano, evitás el susto tarde.'
}, {
  number: 3,
  title: 'Kit Anti-Picos Express',
  description: 'Un protocolo de 10 minutos para después de una comida pesada. Tres versiones: casa, trabajo y asado. Sin gimnasio, sin pastillas, sin irse de la mesa.',
  image: 'https://cdn.magicpatterns.com/uploads/mGWupp33G59swixDCTAQmw/Kit-Anti-Picos-Express-Post-Comida-en-10-Min.png',
  value: '$410 UYU',
  quote: 'No cambies tu comida hoy. Cambiá lo que hacés después.'
}];
export function BonusesSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-16 px-4 bg-white" data-id="element-18">
      <div className="max-w-4xl mx-auto" data-id="element-19">
        {/* HEADLINE */}
        <div className="text-center mb-10" data-id="element-20">
          <Gift className="h-10 w-10 text-emerald-600 mx-auto mb-4" data-id="element-21" />
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-3 uppercase tracking-tight" data-id="element-22">
            Cuando comprás hoy, recibís esto también
          </h2>
          <p className="text-lg text-emerald-700 font-semibold" data-id="element-23">
            Sin costo extra. Sin trampa. Sin vencimiento.
          </p>
        </div>

        {/* INTRO (condensed) */}
        <div className="max-w-2xl mx-auto text-center mb-12" data-id="element-24">
          <p className="text-gray-700 mb-3" data-id="element-25">
            La mayoría falla porque no sabe cómo arrancar, no reconoce las
            señales de su cuerpo, o corta la racha después del asado del sábado.
          </p>
          <p className="font-bold text-gray-900" data-id="element-26">
            Estos 3 bonos son las piezas que faltaban para que el protocolo
            funcione en tu vida real.
          </p>
          <p className="text-xl font-extrabold text-emerald-700 mt-2" data-id="element-27">
            Y hoy son completamente gratis.
          </p>
        </div>

        {/* BONUS CARDS (compact) */}
        <div className="space-y-8 mb-14" data-id="element-28">
          {bonuses.map((bonus, idx) => <div key={bonus.number} className="bg-gray-50 rounded-2xl border border-gray-200 shadow-sm overflow-hidden relative" data-id="element-29">
              <div className="absolute top-0 right-0 bg-emerald-600 text-white px-4 py-1.5 rounded-bl-lg font-bold text-xs uppercase flex items-center gap-1.5" data-id="element-30">
                <Gift className="h-3.5 w-3.5" data-id="element-31" /> GRATIS HOY
              </div>

              <div className={`flex flex-col ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'} items-center`} data-id="element-32">
                <div className="w-full md:w-2/5 p-4 md:p-6" data-id="element-33">
                  <img src={bonus.image} alt={bonus.title} className="w-full rounded-xl shadow-md" data-id="element-34" />
                </div>
                <div className="w-full md:w-3/5 p-6 md:p-8" data-id="element-35">
                  <div className="flex items-center gap-2 mb-2" data-id="element-36">
                    <span className="bg-emerald-100 text-emerald-800 text-xs font-bold px-2.5 py-1 rounded-full" data-id="element-37">
                      BONO #{bonus.number}
                    </span>
                    <span className="text-gray-400 line-through text-sm" data-id="element-38">
                      {bonus.value}
                    </span>
                    <span className="text-emerald-700 font-bold text-sm" data-id="element-39">
                      GRATIS
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-40">
                    {bonus.title}
                  </h3>
                  <p className="text-gray-700 text-sm leading-relaxed mb-4" data-id="element-41">
                    {bonus.description}
                  </p>
                  <div className="bg-emerald-50 text-emerald-800 p-3 rounded-lg text-sm italic border-l-4 border-emerald-500" data-id="element-42">
                    "{bonus.quote}"
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        {/* VALUE SUMMARY (compact) */}
        <div className="max-w-lg mx-auto mb-12" data-id="element-43">
          <div className="bg-white rounded-xl border border-gray-200 shadow-md overflow-hidden" data-id="element-44">
            <div className="divide-y divide-gray-100" data-id="element-45">
              {bonuses.map(b => <div key={b.number} className="flex items-center justify-between px-5 py-3" data-id="element-46">
                  <div className="flex items-center gap-2 text-sm font-medium text-gray-800" data-id="element-47">
                    <Gift className="h-4 w-4 text-emerald-600 flex-shrink-0" data-id="element-48" />
                    {b.title}
                  </div>
                  <span className="text-sm text-gray-400 line-through" data-id="element-49">
                    {b.value}
                  </span>
                </div>)}
            </div>
            <div className="bg-emerald-600 text-white flex items-center justify-between px-5 py-4" data-id="element-50">
              <span className="font-extrabold" data-id="element-51">LO QUE PAGÁS HOY</span>
              <span className="font-extrabold text-xl" data-id="element-52">$0 UYU</span>
            </div>
          </div>
        </div>

        {/* URGENCY (compact) */}
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 mb-10 text-center max-w-2xl mx-auto" data-id="element-53">
          <AlertTriangle className="h-8 w-8 text-amber-500 mx-auto mb-3" data-id="element-54" />
          <p className="text-amber-800 mb-2" data-id="element-55">
            Estos bonos están disponibles porque estamos en período de
            lanzamiento. No sabemos hasta cuándo.
          </p>
          <p className="text-amber-900 font-bold italic" data-id="element-56">
            "Menos mal que lo agarré cuando estaba así."
          </p>
        </div>

        {/* CTA */}
        <div className="text-center" data-id="element-57">
          <Button size="xl" onClick={scrollToOffer} className="shadow-xl text-lg w-full max-w-xl mb-3" data-id="element-58">
            Sí, quiero el protocolo + los 3 bonos gratis
            <ArrowRight className="ml-2 h-5 w-5" data-id="element-59" />
          </Button>
          <div className="flex items-center justify-center gap-2 text-emerald-700 font-medium text-sm" data-id="element-60">
            <ShieldCheck className="h-4 w-4 flex-shrink-0" data-id="element-61" />
            <span data-id="element-62">
              Garantía de 7 días — Si no ves resultados, te devolvemos cada
              peso.
            </span>
          </div>
        </div>
      </div>
    </section>;
}